// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle--18YvP{cursor:pointer;margin:0 auto;padding:30px}.toggle--18YvP .bar--3zgIJ{background:#fff;display:block;height:4px;transition:all 0.3s ease;width:30px}.toggle--18YvP .bar--3zgIJ+.bar--3zgIJ{margin-top:6px}\n", ""]);
// Exports
exports.locals = {
	"toggle": "toggle--18YvP",
	"bar": "bar--3zgIJ"
};
module.exports = exports;
